import React, { useEffect, useState, useContext } from 'react'
import { CCol, CFormCheck, CRow, CFormSelect } from '@coreui/react'
import TagsInput from 'react-tagsinput'
import '../cms/react-tagsinput.css'
import Accordion from 'src/components/Accordion/Accordion'
import Multiselect from 'multiselect-react-dropdown'
import { isEmpty } from 'src/views/utils/helper'
import { capitalCase } from 'change-case'
import { AppContext } from 'src/views/context/app'

const DynamicSwimlane = ({
  subCategories,
  categories,
  countries,
  customMetadataMaster,
  customMetadata,
  subscriptions,
  setFilterPayload,
  editData,
}) => {
  const [filters, setFilters] = useState({})
  const [textAreaValues, setTextAreaValues] = useState([])
  const [selectedCountries, setSelectedCountries] = useState([])
  const [tags, setTags] = useState([])
  const [dynamicSelectValues, setDynamicSelectValues] = useState({})

  const language = localStorage.getItem('language')
  const { accountObj } = useContext(AppContext)
  const defaultLangCheck = language === accountObj?.default_language

  const editFlag = !isEmpty(editData)

  console.log(editFlag)

  useEffect(() => {
    setFilterPayload(filters)
  }, [filters])

  useEffect(() => {
    if (editFlag) {
      handleEdit()
    }
  }, [editFlag])

  useEffect(() => {
    handleDropdownState()
  }, [])

  const handleDropdownState = () => {
    let dropdownObj = {}

    customMetadataMaster.forEach((element) => {
      if (element.type === 'dropdown') {
        dropdownObj[`${element._id}`] = ''
      }
    })
    setDynamicSelectValues(dropdownObj)
  }

  const handleEdit = () => {
    setFilters(editData)
    if (editData.hasOwnProperty(`search_tag`)) {
      setTags(editData.search_tag)
    }

    let tempArea = []
    let counrtyArr = []
    let dropdownObj = {}

    for (const key in editData) {
      let element = editData[key]

      let dataObj = {
        category: categories,
        sub_category: subCategories,
        subscription: subscriptions,
      }

      if (key === 'search_tag') {
        element.forEach((ele) => {
          let areaObj = {
            id: ele,
            name: `Tag : ${ele}`,
            type: `search_tag`,
          }
          tempArea.push(areaObj)
        })
      }

      if (key === 'geo_block_countries') {
        element.forEach((ele) => {
          let countryObj = countries.find((obj) => obj.iso2 === ele)
          let areaObj = {
            id: countryObj.iso2,
            name: `Geo-Blocking : ${countryObj.name}`,
            type: `geo_block_countries`,
          }
          counrtyArr.push(countryObj)
          tempArea.push(areaObj)
        })
      }
      if (key === 'custom') {
        for (const customKey in element) {
          let customEle = element[customKey]
          let customObj = customMetadataMaster.find((obj) => obj._id === customKey)
          customEle.forEach((value) => {
            if (customObj.type === 'dropdown') {
              dropdownObj[`${customKey}`] = value
            }
            let areaObj = {
              id: customKey,
              name: `${customObj.name} : ${value}`,
              type: `custom`,
            }
            tempArea.push(areaObj)
          })
        }
      }

      if (key === 'category' || key === 'sub_category' || key === 'subscription') {
        element.forEach((ele) => {
          let obj = dataObj[key].find((obj) => obj._id === ele)
          let areaObj = {
            id: obj._id,
            name: `${capitalCase(key)} : ${obj.name}`,
            type: key,
          }
          tempArea.push(areaObj)
        })
      }
    }
    setDynamicSelectValues(dropdownObj)
    setSelectedCountries(counrtyArr)
    setTextAreaValues(tempArea)
  }

  const handleParentCheck = (event, type) => {
    let { checked } = event.target
    let temp = filters
    checked ? (temp[`${type}`] = []) : delete temp[`${type}`]
    if (!checked) {
      setTextAreaValues(textAreaValues.filter((obj) => obj.type !== type))
    }
    setFilters({ ...temp })
  }

  const handleChildCheck = (event, type, info) => {
    let { checked } = event.target
    if (checked) {
      let temp = filters
      temp[`${type}`].push(info._id)
      let tempObj = {
        id: info._id,
        name: `${capitalCase(type)} : ${info.name}`,
        type: type,
      }
      setTextAreaValues((textAreaValues) => [...textAreaValues, tempObj])
      setFilters({ ...temp })
    } else {
      let temp = filters
      temp[`${type}`] = temp[`${type}`].filter((id) => id !== info._id)
      setFilters({ ...temp })
      setTextAreaValues(textAreaValues.filter((obj) => obj.id !== info._id))
    }
  }

  const handleGeoBlock = (info, type) => {
    if (type === 'add') {
      let temp = filters
      temp[`geo_block_countries`].push(info.iso2)
      let tempObj = {
        id: info.iso2,
        name: `Geo-Blocking : ${info.name}`,
        type: `geo_block_countries`,
      }
      setTextAreaValues((textAreaValues) => [...textAreaValues, tempObj])
      setSelectedCountries((selectedCountries) => [...selectedCountries, info])
      setFilters({ ...temp })
    } else if (type === 'remove') {
      let temp = filters
      temp[`geo_block_countries`] = temp[`geo_block_countries`].filter((iso2) => iso2 !== info.iso2)
      setFilters({ ...temp })
      setTextAreaValues(textAreaValues.filter((obj) => obj.id !== info.iso2))
      setSelectedCountries(selectedCountries.filter((obj) => obj.iso2 !== info.iso2))
    }
  }

  const handleTagChange = (tag) => {
    console.log('tag', tag)
    let temp = filters
    temp[`search_tag`] = tag
    let tagArr = []
    tag.forEach((element) => {
      let tempObj = {
        id: element,
        name: `Tag : ${element}`,
        type: `search_tag`,
      }
      tagArr.push(tempObj)
    })
    setTextAreaValues((textAreaValues) => [
      ...textAreaValues.filter((item) => item.type !== 'search_tag'),
      ...tagArr,
    ])

    setFilters({ ...temp })
    setTags(tag)
  }

  const handleCustomCheck = (event, id) => {
    let { checked } = event.target
    let temp = filters
    if (!temp.hasOwnProperty('custom')) {
      temp[`custom`] = {}
    }
    checked ? (temp.custom[`${id}`] = []) : delete temp.custom[`${id}`]
    if (!checked) {
      setTextAreaValues(textAreaValues.filter((obj) => obj.id !== id))
    }
    setFilters({ ...filters, ...temp })
  }

  const handleCustomChild = (event, info) => {
    if (info.type === 'checkboxes') {
      let { checked, value } = event.target

      if (checked) {
        let temp = filters.custom
        temp[`${info._id}`].push(value)
        let tempObj = {
          id: info._id,
          name: `${info.name} : ${value}`,
          type: 'custom',
        }
        setTextAreaValues((textAreaValues) => [...textAreaValues, tempObj])
        setFilters((filters) => ({ ...filters, custom: temp }))
      } else {
        let temp = filters.custom
        temp[`${info._id}`] = temp[`${info._id}`].filter((name) => name !== value)
        setFilters((filters) => ({ ...filters, custom: temp }))

        let originalArr = textAreaValues.filter((obj) => obj.type !== 'custom')
        let removeCustomArr = textAreaValues.filter(
          (obj) => obj.type === 'custom' && obj.id !== info._id,
        )
        let removeArr = textAreaValues.filter(
          (obj) =>
            obj.type === 'custom' && obj.id === info._id && obj.name !== `${info.name} : ${value}`,
        )
        setTextAreaValues([...originalArr, ...removeCustomArr, ...removeArr])
      }
    } else {
      let { value } = event.target
      let temp = filters.custom
      temp[`${info._id}`] = [value]
      let tempObj = {
        id: info._id,
        name: `${info.name} : ${value}`,
        type: 'custom',
      }
      if (info.type === 'dropdown') {
        setDynamicSelectValues({ ...dynamicSelectValues, [info._id]: value })
      }
      setTextAreaValues((textAreaValues) => [
        ...textAreaValues.filter((ele) => ele.id !== info._id),
        tempObj,
      ])
      setFilters((filters) => ({ ...filters, custom: temp }))
    }
  }

  const customRender = (info) => {
    switch (info.type) {
      case 'checkboxes':
        return info.range_values.map((ele, index) => (
          <CFormCheck
            key={index}
            type="checkbox"
            className="mx-1"
            label={`${ele}`}
            value={ele}
            checked={checkChildExists(`custom`, ele, info._id)}
            onChange={(e) => handleCustomChild(e, info)}
            disabled={!defaultLangCheck}
          />
        ))
      case 'dropdown':
        return (
          <CFormSelect
            className=""
            value={dynamicSelectValues[info._id]}
            onChange={(e) => handleCustomChild(e, info)}
            disabled={!defaultLangCheck}
          >
            <option disabled value="" selected>
              Select Option
            </option>
            {info.range_values.map((ele, index) => (
              <option value={ele} key={index}>
                {ele}
              </option>
            ))}
          </CFormSelect>
        )

      case 'radio':
        return info.range_values.map((ele, index) => (
          <CFormCheck
            key={index}
            type="radio"
            className="mx-1"
            name={`${info._id}`}
            label={`${ele}`}
            value={ele}
            checked={checkChildExists(`custom`, ele, info._id)}
            onChange={(e) => handleCustomChild(e, info)}
            disabled={!defaultLangCheck}
          />
        ))
      default:
        return
    }
  }

  const handleRemoveTextArea = (info) => {
    if (info.type === 'custom') {
      let originalArr = textAreaValues.filter((obj) => obj.type !== 'custom')

      let removeCustomArr = textAreaValues.filter(
        (obj) => obj.type === 'custom' && obj.id !== info.id,
      )
      let removeArr = textAreaValues.filter(
        (obj) => obj.type === 'custom' && obj.id === info.id && obj.name !== info.name,
      )
      setTextAreaValues([...originalArr, ...removeCustomArr, ...removeArr])

      if (dynamicSelectValues.hasOwnProperty(`${info.id}`)) {
        setDynamicSelectValues({ ...dynamicSelectValues, [info.id]: '' })
      }

      let temp = filters.custom
      const elemName = info.name.split(':')[1]
      temp[`${info.id}`] = temp[`${info.id}`].filter((ele) => ele !== elemName.trim())
      if (temp[`${info.id}`].length === 0) {
        delete temp[`${info.id}`]
      }
      setFilters((filters) => ({ ...filters, custom: temp }))
    } else {
      if (info.type === 'geo_block_countries') {
        setSelectedCountries(selectedCountries.filter((obj) => obj.iso2 !== info.id))
      }
      if (info.type === 'search_tag') {
        setTags(tags.filter((ele) => ele !== info.id))
      }
      setTextAreaValues((textAreaValues) => textAreaValues.filter((obj) => obj.id !== info.id))
      let temp = filters
      temp[`${info.type}`] = temp[`${info.type}`].filter((ele) => ele !== info.id)
      setFilters({ ...temp })
    }
  }

  const checkChildExists = (type, id, customType) => {
    if (type === 'custom') {
      return filters.custom[customType].includes(id)
    }

    return filters[type].includes(id)
  }

  return (
    <>
      <CRow>
        <p className="swimlane-options">Define swimlane criteria</p>
      </CRow>
      <CRow className="mt-3">
        <CCol className="swimlane-container">
          <Accordion title={'System Defined'}>
            <CFormCheck
              type="checkbox"
              name="flexRadioDefault"
              label="Geo-blocking"
              checked={filters.hasOwnProperty('geo_block_countries')}
              onChange={(e) => handleParentCheck(e, `geo_block_countries`)}
              disabled={!defaultLangCheck}
            />
            {filters.hasOwnProperty('geo_block_countries') && (
              <div className="mx-4 ">
                <Multiselect
                  options={defaultLangCheck ? countries : []} // Options to display in the dropdown
                  selectedValues={selectedCountries}
                  color="red"
                  style={{
                    chips: {
                      background: 'blue',
                    },
                    searchBox: {
                      background: 'white',
                    },
                  }}
                  showCheckbox="true"
                  onSelect={(e, info) => handleGeoBlock(info, 'add')}
                  onRemove={(e, info) => handleGeoBlock(info, 'remove')}
                  displayValue="name" // Property name to display in the dropdown options
                  disablePreSelectedValues={!defaultLangCheck}
                />
              </div>
            )}
            <CFormCheck
              type="checkbox"
              name="flexRadioDefault"
              label="Category"
              checked={filters.hasOwnProperty('category')}
              onChange={(e) => handleParentCheck(e, `category`)}
              disabled={!defaultLangCheck}
            />
            {filters.hasOwnProperty('category') && (
              <div className="mx-4 border system-box">
                {categories.map((info, index) => (
                  <CFormCheck
                    key={index}
                    type="checkbox"
                    className="mx-1"
                    name="flexRadioDefault"
                    label={`${info.name}`}
                    checked={checkChildExists(`category`, info._id)}
                    onChange={(e) => handleChildCheck(e, `category`, info)}
                    disabled={!defaultLangCheck}
                  />
                ))}
              </div>
            )}
            <CFormCheck
              type="checkbox"
              name="flexRadioDefault"
              label="Sub-category"
              checked={filters.hasOwnProperty('sub_category')}
              onChange={(e) => handleParentCheck(e, `sub_category`)}
              disabled={!defaultLangCheck}
            />
            {filters.hasOwnProperty('sub_category') && (
              <div className="mx-4 border system-box">
                {subCategories.map((info, index) => (
                  <CFormCheck
                    key={index}
                    type="checkbox"
                    className="mx-1"
                    name="flexRadioDefault"
                    label={`${info.name}`}
                    value={info._id}
                    checked={checkChildExists(`sub_category`, info._id)}
                    onChange={(e) => handleChildCheck(e, `sub_category`, info)}
                    disabled={!defaultLangCheck}
                  />
                ))}
              </div>
            )}

            <CFormCheck
              type="checkbox"
              name="flexRadioDefault"
              label="Subscription"
              checked={filters.hasOwnProperty('subscription')}
              onChange={(e) => handleParentCheck(e, `subscription`)}
              disabled={!defaultLangCheck}
            />
            {filters.hasOwnProperty('subscription') && (
              <div className="mx-4 border system-box">
                {subscriptions.map((info, index) => (
                  <CFormCheck
                    key={index}
                    type="checkbox"
                    className="mx-1"
                    name="flexRadioDefault"
                    label={`${info.name}`}
                    value={info._id}
                    checked={checkChildExists(`subscription`, info._id)}
                    onChange={(e) => handleChildCheck(e, `subscription`, info)}
                    disabled={!defaultLangCheck}
                  />
                ))}
              </div>
            )}

            <CFormCheck
              type="checkbox"
              name="flexRadioDefault"
              label="Tagging"
              checked={filters.hasOwnProperty('search_tag')}
              onChange={(e) => handleParentCheck(e, `search_tag`)}
              disabled={!defaultLangCheck}
            />
            {filters.hasOwnProperty('search_tag') && (
              <div className="mx-4 border system-box">
                <TagsInput
                  value={tags}
                  onChange={(tag) => handleTagChange(tag)}
                  disabled={!defaultLangCheck}
                />
              </div>
            )}
          </Accordion>
          <Accordion title={'Custom Defined'}>
            {customMetadataMaster.map((info, index) => (
              <>
                <CFormCheck
                  type="checkbox"
                  name="flexRadioDefault"
                  label={`${info.name}`}
                  key={index}
                  checked={
                    filters.hasOwnProperty('custom') && filters.custom.hasOwnProperty(info._id)
                  }
                  onChange={(e) => handleCustomCheck(e, info._id)}
                  disabled={!defaultLangCheck}
                />
                {filters.custom && filters.custom.hasOwnProperty(`${info._id}`) && (
                  <div className="mx-4 border system-box">{customRender(info)}</div>
                )}
              </>
            ))}
          </Accordion>
        </CCol>
        <CCol lg="6">
          <Multiselect
            options={defaultLangCheck ? textAreaValues : []} // Options to display in the dropdown
            selectedValues={textAreaValues}
            color="red"
            style={{
              chips: {
                background: 'blue',
              },
              searchBox: {
                background: 'white',
                minHeight: '10rem',
              },
            }}
            className="swimlane-Textarea"
            showCheckbox="true"
            onRemove={(e, info) => handleRemoveTextArea(info)}
            displayValue="name" // Property name to display in the dropdown options
            disablePreSelectedValues={!defaultLangCheck}
          />
        </CCol>
      </CRow>
    </>
  )
}

export default DynamicSwimlane
